import ACTIONS from './TCardActions';
const reducers = (state, action) => {
    switch (action.type) {
        case ACTIONS.SHOW_CARD_FORM:
            return Object.assign(Object.assign({}, state), { showCardForm: !!action.payload });
        case ACTIONS.SET_CARD:
            return Object.assign(Object.assign({}, state), { card: action.payload });
        case ACTIONS.SHOW_TEST_CARD:
            return Object.assign(Object.assign({}, state), { testCard: action.payload });
        case ACTIONS.SET_CAPCTHA:
            return Object.assign(Object.assign({}, state), { captcha: action.payload });
        case ACTIONS.SELECT_PAYMENT_TYPE:
            return Object.assign(Object.assign({}, state), { paymentType: action.payload });
        case ACTIONS.SET_CAPTCHA_TOKEN:
            return Object.assign(Object.assign({}, state), { captchaToken: action.payload });
        case ACTIONS.SET_MUTATE:
            return Object.assign(Object.assign({}, state), { mutate: action.payload });
        default:
            return state;
    }
};
export default reducers;
